import React from 'react'
import {Container, Row, Col } from 'reactstrap';
import tapa from "../../src/assets/images/Firmando.jpeg";
import backgroundtextura from "../../src/assets/images/textura.jpg";
import "../styles/Contact.css";





const Contact = () => {
return (
    <><div style={{ backgroundImage: `url(${backgroundtextura})` }}>
    <section className="book-section2">
        <Container fluid="true" className="container-book-section2" >
            <Row noGutters className="book-section2">
                <Col lg='3' md='3'>
                    <img src={tapa} alt="tapa del libro" className='tapaLibro2' />
                </Col>
                
                <Col lg='8' md='8' className="info-contact">
                    <div> 
                        <h3 className="redes">Mis redes</h3>
                        <p><a href="https://www.instagram.com/t.cuent.o/"  target='blank' className='links-contact'> <i class="ri-instagram-line"></i> </a> —   @t.cuent.o // @cecyviv   — </p>
                        {/* <p > <i class="ri-facebook-box-line"></i>—   Cecilia Vivanco   — </p> */}
                        <p > <a href="https://www.facebook.com/acvivanco" target='blank' className='links-contact'><i class="ri-facebook-box-line"></i></a> —   Cecilia Vivanco   — </p>
                        <p><i class="ri-mail-line"></i>—   acvivanco@gmail.com   —  </p>
                        
                    </div>
                </Col>
            </Row>
        </Container>






    </section>
    </div></>
)
}

export default Contact